(() => {
  const GIFT_FLAG = '_gift';
  const PARENT_KEY = '_parent_key';
  const PARENT_VID = '_parent_variant_id';

  function resolveGiftVariantId(mainVariantId) {
    const map = window.__GIFT_MAP__ || {};
    const token = map[String(mainVariantId)];
    if (!token) return null;

    // If token is a numeric ID
    if (/^\d+$/.test(token)) return Number(token);

    // If token is a GraphQL gid
    if (/^gid:\/\//.test(token)) {
      const m = String(token).match(/ProductVariant\/(\d+)/);
      return m ? Number(m[1]) : null;
    }

    // Otherwise assume it's a SKU and resolve via optional SKU map
    const skuMap = window.__GIFT_SKU_TO_ID__ || {};
    return skuMap[token] || null;
  }

  async function addJson(url, payload) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  // --- Add main, then gift (so we can attach parent line key to the gift) ---
  async function addMainThenGift(mainVariantId, qty) {
    // 1) Add main
    const mainLine = await addJson('/cart/add.js', { id: mainVariantId, quantity: qty });

    // 2) Resolve gift and add it (if found)
    const giftId = resolveGiftVariantId(mainVariantId);
    if (giftId) {
      await addJson('/cart/add.js', {
        id: giftId,
        quantity: qty,
        properties: {
          [GIFT_FLAG]: 'true',
          [PARENT_KEY]: mainLine.key,
          [PARENT_VID]: String(mainVariantId),
        },
      });
    }

    document.dispatchEvent(new CustomEvent('cart:refresh')); // your theme can listen to this
  }

  // Intercept product form submit
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('product-form form, form[action="/cart/add"]')) return;

    try {
      const fd = new FormData(form);
      const mainId = Number(fd.get('id'));
      const qty = Number(fd.get('quantity') || 1);
      if (!mainId) return;

      e.preventDefault();
      addMainThenGift(mainId, qty).catch(() => form.submit()); // fallback: add normally
    } catch {
      /* no-op */
    }
  });

  // ----------------- CART SYNC (optional but recommended) -----------------
  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  async function changeLine(lineIndex, quantity) {
    await addJson('/cart/change.js', { line: lineIndex, quantity });
  }

  // Keep gift quantity == parent quantity; remove orphan gifts
  async function syncGifts() {
    const cart = await getCart();
    const items = cart.items || [];
    const byKey = new Map(items.map((it, i) => [it.key, { ...it, _index: i + 1 }]));

    // Remove orphan gifts & fix quantities
    for (const it of items) {
      const isGift = it.properties && it.properties[GIFT_FLAG] === 'true';
      if (!isGift) continue;

      const parentKey = it.properties && it.properties[PARENT_KEY];
      const parent = parentKey && byKey.get(parentKey);

      if (!parent) {
        // parent removed -> remove gift
        await changeLine(it._index, 0);
      } else if (it.quantity !== parent.quantity) {
        await changeLine(it._index, parent.quantity);
      }
    }
  }

  // Run on cart page and whenever your theme updates the cart
  document.addEventListener('cart:refresh', syncGifts);
  if (location.pathname.indexOf('/cart') !== -1) syncGifts();
})();
